/**
 * Common Enums for Farm2Me Application
 * This file contains commonly used enumerations across the application
 */

export enum MenuType {
    ViewAllComplaints = 7,
    RawMaterialQualityCheck = 61,
    OilProductionRecords = 67,
    RolePermissions = 96,
    UnassignedOrders = 16,
    RewardDeatils = 54,
}

export enum ModuleType {
    MyAccount = 1,
    Farm2Me = 2,
    Desiri = 3,
    Administration = 4
}

export enum PermissionType {
    View = 1,
    Create = 2,
    Edit = 3,
    Delete = 4,
    Export = 5,
    Import = 6
}

